import { fetchURL } from './surveyConfigurationState';

const initialState = {
  surveys: [],
};

export const fetchSurveyConfigurations = () => dispatch =>
  fetchURL(dispatch, `/admin/company/survey_configurations`).then(response => {
    dispatch({
      type: 'SET_SURVEYS',
      surveys: response.surveys,
    });
  });

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SURVEYS': {
      const { surveys } = action;

      return { ...state, surveys };
    }

    default:
      return state;
  }
};
